import { render, staticRenderFns } from "./SithMesQualityInspectTemplateAddView.vue?vue&type=template&id=10cb35cf&scoped=true&"
import script from "./SithMesQualityInspectTemplateAddView.vue?vue&type=script&lang=js&"
export * from "./SithMesQualityInspectTemplateAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb35cf",
  null
  
)

export default component.exports